import React, { useState } from 'react';
import {
    Anchor,
    Box,
    Button,
    // CheckBox,
    DataTable,
    Heading,
    Page,
    PageContent,
} from 'grommet';
import { useLoaderData, useRevalidator } from 'react-router-dom';
import { API } from '@enrich/shared-lib';
import QueryString from 'qs';
import { AddToListButton } from './AddToListButton';

export const ContactList = () => {
    const list = useLoaderData();
    const revalidator = useRevalidator();
    const contacts = list.attributes.contacts.data;
    const [selection, setSelection] = useState([]);
    const dataColumns = [
        {
            header: 'Name',
            property: 'attributes.lastName',
            render: (contact) => {
                return (
                    <Anchor
                        href={`/contacts/${contact.id}`}
                        label={`${contact.attributes.firstName} ${contact.attributes.lastName}`}
                    />
                );
            },
            sortable: true,
        },
        {
            header: 'Email',
            property: 'attributes.email',
            sortable: true,
        },
    ];

    const removeFromList = async () => {
        try {
            await API.put(`/api/contact-lists/${list.id}`, {
                data: {
                    contacts: {
                        disconnect: selection,
                    },
                },
            });
            revalidator.revalidate();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Page
            kind="full"
            pad={{ top: '30px', horizontal: 'medium', bottom: '30px' }}>
            <PageContent gap="medium">
                <Heading level="2">{list.attributes.name}</Heading>
                <Box direction="row" gap="small">
                    <Button
                        secondary
                        size="large"
                        label="Remove checked from list"
                        onClick={removeFromList}
                    />
                    <AddToListButton
                        listId={list.id}
                        revalidate={revalidator.revalidate}
                    />
                </Box>
                <Box>
                    <DataTable
                        sortable
                        columns={dataColumns}
                        data={contacts}
                        allowSelectAll
                        primaryKey="id"
                        select={selection}
                        onSelect={(selected) => {
                            setSelection(selected);
                        }}
                        paginate
                    />
                </Box>
            </PageContent>
        </Page>
    );
};

export async function loader({ params }) {
    const query = QueryString.stringify({
        populate: ['contacts'],
    });

    try {
        const response = await API.get(
            `/api/contact-lists/${params.listId}?${query}`,
        );
        return response.data.data;
    } catch (error) {
        console.log(error);
        return {};
    }
}
